import BuildingDetailsList from './BuildingDetailsList.component';

export default BuildingDetailsList;
